import { TicketOption, Voucher, Creator } from "./types";

export const APP_NAME = "Glow Interactive Zoo & Rabbits in Wonderland @ Kebun Binatang Surabaya";

export const TICKET_OPTIONS: TicketOption[] = [
  {
    id: "glow-interactive-zoo-only",
    title: "Glow Interactive Zoo",
    description: "Jelajahi pengalaman imersif satwa digital.",
    price: 15000,
    features: ["Masuk Glow Interactive Zoo (Digital Zoo)"],
    type: "regular",
  },
  {
    id: "rabbits-in-wonderland-only",
    title: "Rabbits in Wonderland",
    description: "Main dan foto bareng kelinci lucu.",
    price: 20000,
    features: ["Masuk Rabbits in Wonderland (Rabbit Village)"],
    type: "regular",
  },
  {
    id: "paket-rabbits-in-wonderland-glow-interactive-zoo",
    title: "Paket Rabbits in Wonderland + Glow Interactive Zoo",
    description: "Akses bundling dua wahana terpopuler.",
    price: 30000,
    originalPrice: 35000,
    features: [
      "Masuk Glow Interactive Zoo (Digital Zoo)",
      "Masuk Rabbits in Wonderland (Rabbit Village)",
      "Feeding Access",
      "Priority Lane",
    ],
    recommended: true,
    type: "fast-track",
  },
  {
    id: "paket-lengkap-kebun-binatang-surabaya",
    title: "Paket Rabbits in Wonderland + Glow Interactive Zoo + Kebun Binatang Surabaya",
    description: "Liburan lengkap tanpa ribet beli tiket berkali-kali.",
    price: 45000,
    originalPrice: 50000,
    features: [
      "Masuk Kebun Binatang Surabaya",
      "Masuk Glow Interactive Zoo (Digital Zoo)",
      "Masuk Rabbits in Wonderland (Rabbit Village)",
      "Feeding Access",
      "Priority Lane",
    ],
    recommended: true,
    type: "fast-track",
  },
];

export const DEFAULT_CREATORS: Creator[] = [
  {
    id: "creator_ochi",
    name: "NICHAOCHI_SYER",
    platform: "IG: @nichaochi_syer",
    joinedDate: "2025-03-03",
    tier: "Macro",
    followersCount: "115.937",
    whatsapp: "083151482478",
    bankName: "BCA",
    bankAccountNumber: "8291051383",
    bankAccountName: "Yoshinta Rizky ASR SE",
  },
  {
    id: "creator_anisa",
    name: "ANISA OKTAVIANI",
    platform: "IG: @anisaoktavia_ni",
    joinedDate: "2025-03-03",
    tier: "Micro",
    followersCount: "12.000",
    whatsapp: "089654977725",
    bankName: "Dana",
    bankAccountNumber: "089654977725",
    bankAccountName: "Anisa Oktaviani",
  },
  {
    id: "creator_irene",
    name: "IRENE NARDA",
    platform: "IG: @meirinchan29",
    joinedDate: "2025-03-03",
    tier: "Micro",
    followersCount: "72.000",
    whatsapp: "0883200192",
    bankName: "BCA",
    bankAccountNumber: "0883200192",
    bankAccountName: "Irene Narda Lawanto",
  },
  {
    id: "creator_fadya",
    name: "FADYA PUTRI HARNINTYA",
    platform: "IG: @papaddiya",
    joinedDate: "2025-03-03",
    tier: "Micro",
    followersCount: "18.200",
    whatsapp: "082323269778",
    bankName: "BCA",
    bankAccountNumber: "8221354354",
    bankAccountName: "Fadya Putri Harnintya",
  },
];

export const CREATOR_VOUCHERS: Voucher[] = [
  {
    id: "v_ochi",
    code: "GIZOCHI",
    type: "percent",
    value: 10,
    creatorId: "creator_ochi",
    creatorName: "NICHAOCHI_SYER",
  },
  {
    id: "v_anisa",
    code: "GIZNISA",
    type: "percent",
    value: 10,
    creatorId: "creator_anisa",
    creatorName: "ANISA OKTAVIANI",
  },
  {
    id: "v_irene",
    code: "GIZMEIRIN",
    type: "percent",
    value: 10,
    creatorId: "creator_irene",
    creatorName: "IRENE NARDA",
  },
  {
    id: "v_fadya",
    code: "GIZCIPA",
    type: "percent",
    value: 10,
    creatorId: "creator_fadya",
    creatorName: "FADYA PUTRI HARNINTYA",
  },
];

export const KBS_ENTRY_PRICE = 15000;

export const GALLERY_IMAGES = [
  {
    id: 1,
    url: "https://ik.imagekit.io/publish/GIZ/1.jpg",
    category: "Glow Interactive Zoo",
    caption: "Interaksi digital dengan proyeksi satwa purba",
  },
  {
    id: 2,
    url: "https://ik.imagekit.io/publish/GIZ/2.jpg",
    category: "GIZ Park",
    caption: "Zona edukasi interaktif untuk anak-anak",
  },
  {
    id: 3,
    url: "https://ik.imagekit.io/publish/GIZ/3.jpg",
    category: "GIZ Park",
    caption: "Memberi makan kelinci di Feeding Corner",
  },
  {
    id: 4,
    url: "https://ik.imagekit.io/publish/GIZ/4.jpg",
    category: "GIZ Park",
    caption: "Lorong cahaya imersif",
  },
  {
    id: 5,
    url: "https://ik.imagekit.io/publish/RIW/1.jpg",
    category: "Rabbits in Wonderland",
    caption: "Memberi makan kelinci di Feeding Corner",
  },
  {
    id: 6,
    url: "https://ik.imagekit.io/publish/RIW/2.PNG",
    category: "RIW",
    caption: "Kelinci lucu di Rabbit Island Wonderland",
  },
  {
    id: 7,
    url: "https://ik.imagekit.io/publish/RIW/3.PNG",
    category: "RIW",
    caption: "Keseruan anak-anak bermain dengan kelinci",
  },
  {
    id: 8,
    url: "https://ik.imagekit.io/publish/RIW/4.PNG",
    category: "RIW",
    caption: "Rabbit village yang penuh warna",
  },
  {
    id: 9,
    url: "https://ik.imagekit.io/publish/RIW/5.PNG",
    category: "RIW",
    caption: "Rumah kelinci yang instagramable",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Keluarga Hartono",
    role: "Pengunjung Keluarga",
    avatar: "https://i.pravatar.cc/150?u=hartono",
    quote:
      "Anak-anak senang sekali! Di Glow Interactive Zoo mereka belajar soal hewan digital, terus lanjut main sama kelinci asli di Rabbits in Wonderland. Paket Fast Track sangat worth it.",
    rating: 5,
  },
  {
    id: 2,
    name: "Ibu Sari & Dinda",
    role: "Ibu Rumah Tangga",
    avatar: "https://i.pravatar.cc/150?u=sari",
    quote:
      "Edukatif banget. Glow Interactive Zoo canggih, anak saya suka banget pas bagian proyeksi lantai interaktif. Rabbits in Wonderland-nya juga bersih dan kelincinya gemuk-gemuk.",
    rating: 5,
  },
  {
    id: 3,
    name: "Dimas A.",
    role: "Mahasiswa",
    avatar: "https://i.pravatar.cc/150?u=dimas",
    quote:
      "Spot fotonya estetik parah buat konten. Glow Interactive Zoo vibes-nya futuristik, kalau Rabbits in Wonderland lebih ke cute. Cocok buat date atau ajak adik kecil.",
    rating: 4,
  },
];

export const FAQ_DATA = [
  {
    q: "Apa itu Glow Interactive Zoo?",
    a: "Wahana baru yang menggabungkan sensasi dunia nyata dan digital untuk pengalaman menjelajah habitat satwa yang imersif.",
  },
  {
    q: "Apa bedanya dengan Rabbits in Wonderland?",
    a: "Rabbits in Wonderland berfokus pada interaksi langsung dengan kelinci, seperti memberi makan dan berfoto di area tematik.",
  },
  {
    q: "Apakah tiket sudah termasuk masuk Kebun Binatang Surabaya?",
    a: "Tergantung pilihan tiket Anda. Kami menyediakan paket bundling yang sudah termasuk tiket masuk Kebun Binatang Surabaya utama (Rp15.000).",
  },
];
